//Using simple `enum` and not `const enum` because `const enum` members are inlined at compilation and in DateRelationFilter.tsx, Object.values(DATE_RELATIONS) is used
export enum DATE_RELATIONS {
  PREVIOUS = 'previous',
  NEXT = 'next',
  CURRENT = 'current',
  BEFORE = 'before',
  AFTER = 'after',
  ON = 'on',
  BETWEEN = 'between',
  IN_THE_LAST = 'in_the_last',
  IN_THE_NEXT = 'in_the_next',
  IN_THIS_HOUR = 'in_this_hour',
  TODAY = 'today',
  IN_THIS_WEEK = 'in_this_week',
  IN_THIS_MONTH = 'in_this_month',
  IN_THIS_YEAR = 'in_this_year',
  NEVER = 'never',
}

export const CURRENT_DATE_RELATIONS = [
  DATE_RELATIONS.IN_THIS_HOUR,
  DATE_RELATIONS.TODAY,
  DATE_RELATIONS.IN_THIS_WEEK,
  DATE_RELATIONS.IN_THIS_MONTH,
  DATE_RELATIONS.IN_THIS_YEAR,
  DATE_RELATIONS.NEVER,
] as const;

// for the places where we use the old date filter and need all the excluded options
export const EXCLUDED_RELATIONS = {
  [DATE_RELATIONS.IN_THE_LAST]: true,
  [DATE_RELATIONS.IN_THE_NEXT]: true,
  [DATE_RELATIONS.IN_THIS_HOUR]: true,
  [DATE_RELATIONS.TODAY]: true,
  [DATE_RELATIONS.IN_THIS_WEEK]: true,
  [DATE_RELATIONS.IN_THIS_MONTH]: true,
  [DATE_RELATIONS.IN_THIS_YEAR]: true,
  [DATE_RELATIONS.NEVER]: true,
};
